var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { CheckableSelectItem, DropdownSelectMultiple, } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { PureComponent } from 'react';
import styles from './teamsSelect.module.scss';
export class TeamsSelect extends PureComponent {
    getExtraParams() {
        const { queueId } = this.props;
        const params = {};
        if (queueId) {
            params.filter_out_by_queue = queueId;
        }
        return params;
    }
    componentDidMount() {
        this.props.teams.setExtraParams(this.getExtraParams()).then(() => {
            this.props.teams.getItems();
        });
    }
    handleChange(team, isSelected) {
        const { selectTeam, deselectTeam } = this.props;
        if (isSelected) {
            selectTeam(team);
        }
        else {
            deselectTeam(team);
        }
    }
    handleMenuToggle(isOpen) {
        if (!isOpen && this.props.teams.searchTerm) {
            // `DropdownSelectMultiple` removes `searchTerm` on close, so we need to handle that
            this.props.teams.searchTermChange('', 0);
        }
    }
    render() {
        const { teams, selectedItems, deselectTeam, buttonText } = this.props;
        const { items, searchTermChange, getItemsAsyncStatus, searchTerm, hasNextPage, hasPreviousPage, nextPage, previousPage, } = teams;
        const tooltipItems = [...items, ...selectedItems];
        return (_jsx(DropdownSelectMultiple, { selectedItems: selectedItems, onRemove: deselectTeam, containerProps: { className: styles.teamsSelectContainer }, items: items, itemComponent: CheckableSelectItem, tooltipItems: Object.assign({}, ...tooltipItems.map((i) => ({
                [i.id]: { content: i.name, dark: true },
            }))), onSearch: searchTermChange, onChange: this.handleChange, keepOpen: true, hasSearch: true, buttonProps: { isLoading: getItemsAsyncStatus === 'loading' }, emptyMessage: searchTerm ? 'No teams found' : 'No teams available', buttonText: buttonText, pagination: {
                nextEnable: hasNextPage,
                previousEnable: hasPreviousPage,
                onNext: nextPage,
                onPrevious: previousPage,
            }, onToggle: this.handleMenuToggle }));
    }
}
TeamsSelect.defaultProps = {
    buttonText: '+Add team',
};
__decorate([
    boundMethod
], TeamsSelect.prototype, "handleChange", null);
__decorate([
    boundMethod
], TeamsSelect.prototype, "handleMenuToggle", null);
